import { Bell } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { formatDate } from '@/lib/format';
import { useNotifications } from '@/features/notifications/notificationsApi';
import { TaskCard, TaskRow } from './TaskCard';

/**
 * Meine neuesten Benachrichtigungen (ADR 0062). Serverseitig bereits auf den
 * aktuellen Nutzer beschränkt — keine Berechtigung nötig, jeder hat eigene.
 */
export function NotificationsWidget() {
  const query = useNotifications({ limit: 8 });
  const items = query.data?.data ?? [];

  return (
    <TaskCard
      title="Benachrichtigungen"
      icon={Bell}
      isLoading={query.isLoading}
      isEmpty={items.length === 0}
      emptyText="Keine Benachrichtigungen."
    >
      {items.map((item) => (
        <TaskRow
          key={item.id}
          to={item.linkPath ?? undefined}
          left={
            <>
              {item.readAt === null && <span className="mr-2 inline-block size-2 rounded-full bg-primary align-middle" aria-label="ungelesen" />}
              <span className="text-foreground">{item.title}</span>
              {item.body && <span className="ml-2 text-xs text-muted-foreground">{item.body}</span>}
            </>
          }
          right={<Badge tone="neutral">{formatDate(item.createdAt)}</Badge>}
        />
      ))}
    </TaskCard>
  );
}
